/// <reference path="../../lib/jQuery.d.ts" />
/// <reference path="../core/configuration.ts" />

import { Dimensioning } from "../core/dimensioning";
import { Utils } from "../core/utils";
import { Corner } from "../model/corner";
import { Floorplan } from "../model/floorplan";
import { HalfEdge } from "../model/half_edge";
import { Room } from "../model/room";
import { Wall } from "../model/wall";
import { Floorplanner } from "./floorplanner";

  /** */
  export const floorplannerModes = {
    MOVE: 0,
    DRAW: 1,
    DELETE: 2
  };

  // grid parameters
  const gridSpacing = 20; // pixels
  const gridWidth = 1;
  const gridColor = "#f1f1f1";

  // room config
  const roomColor = "#f9f9f9";

  // wall config
  const wallWidth = 5;
  const wallWidthHover = 7;
  const wallColor = "#dddddd"
  const wallColorHover = "#008cba"
  const wallColorSelected = "#00a0d2"
  const edgeColor = "#888888"
  const edgeColorHover = "#008cba"
  const edgeWidth = 1

  const wallHandleLineColor = "#00a0d2";
  const wallHeightSpinnerBorder = "#0078a3";
  const wallHeightSpinnerBg = "#ffffff";
  const wallHeightSpinnerHover = "#dff3fb";
  const wallHeightArrowColor = "#0078a3";

  const deleteColor = "#ff0000";

  // corner config
  const cornerRadius = 0
  const cornerRadiusHover = 7
  const cornerColor = "#cccccc"
  const cornerColorHover = "#008cba"

  /**
   * The View to be used by a Floorplanner to render in/interact with.
   */
  export class FloorplannerView {

    /** The canvas element. */
    private canvasElement: HTMLCanvasElement;

    /** The 2D context. */
    private context;

    /** */
    constructor(private floorplan: Floorplan, private viewmodel: Floorplanner, private canvas: string) {
      this.canvasElement = <HTMLCanvasElement>document.getElementById(canvas);
      this.context = this.canvasElement.getContext('2d');

      var scope = this;
      $(window).resize(() => {
        scope.handleWindowResize();
      });
      this.handleWindowResize();
    }

    /** */
    public handleWindowResize() {
      var canvasSel = $("#" + this.canvas);
      var parent = canvasSel.parent();
      canvasSel.height(parent.innerHeight());
      canvasSel.width(parent.innerWidth());
      this.canvasElement.height = parent.innerHeight();
      this.canvasElement.width = parent.innerWidth();
      this.draw();
    }

    /** */
    public draw() {
      this.context.clearRect(0, 0, this.canvasElement.width, this.canvasElement.height);

      this.drawGrid();

      this.floorplan.getRooms().forEach((room) => {
        this.drawRoom(room);
      })

      this.floorplan.getWalls().forEach((wall) => {
        this.drawWall(wall);
      });

      this.floorplan.getCorners().forEach((corner) => {
        this.drawCorner(corner);
      });

      if (this.viewmodel.mode == floorplannerModes.DRAW) {
        this.drawTarget(this.viewmodel.targetX, this.viewmodel.targetY, this.viewmodel.lastNode);
      }

      var wallWithHeightControl = this.viewmodel.selectedWall || this.viewmodel.activeWall;
      if (wallWithHeightControl && this.viewmodel.mode == floorplannerModes.MOVE) {
        this.drawWallHeightControl(wallWithHeightControl);
      }

      this.floorplan.getWalls().forEach((wall) => {
        this.drawWallLabels(wall);
      });
    }

    /** */
    private drawWallLabels(wall: Wall) {
      // we'll just draw the shorter label... idk
      if (wall.backEdge && wall.frontEdge) {
        if (wall.backEdge.interiorDistance < wall.frontEdge.interiorDistance) {
          this.drawEdgeLabel(wall.backEdge);
        } else {
          this.drawEdgeLabel(wall.frontEdge);
        }
      } else if (wall.backEdge) {
        this.drawEdgeLabel(wall.backEdge);
      } else if (wall.frontEdge) {
        this.drawEdgeLabel(wall.frontEdge);
      }
    }

    private drawWallHeightControl(wall: Wall) {
      var ui = this.viewmodel.getWallHeightSpinnerUi(wall);
      if (!ui) {
        return;
      }

      var left = ui.centerX - (ui.width / 2);
      var top = ui.centerY - (ui.totalHeight / 2);
      var upHovered = this.viewmodel.wallHeightHoveredArrow === "up";
      var downHovered = this.viewmodel.wallHeightHoveredArrow === "down";

      this.context.font = "bold 12px Arial";
      this.context.textBaseline = "bottom";
      this.context.textAlign = "center";
      this.context.lineWidth = 3;

      var heightLabel = "Height: " + Dimensioning.cmToMeasure(Math.round(wall.height));

      this.context.strokeStyle = "#ffffff";
      this.context.fillStyle = wallColorSelected;
      this.context.strokeText(heightLabel, ui.labelX, ui.labelY);
      this.context.fillText(heightLabel, ui.labelX, ui.labelY);

      this.drawLine(ui.wallMidX, ui.wallMidY, ui.centerX, ui.centerY, 2, wallHandleLineColor);

      this.context.fillStyle = wallHeightSpinnerBg;
      this.context.strokeStyle = wallHeightSpinnerBorder;
      this.context.lineWidth = 2;
      this.context.beginPath();
      this.context.rect(left, top, ui.width, ui.totalHeight);
      this.context.fill();
      this.context.stroke();

      this.context.fillStyle = upHovered ? wallHeightSpinnerHover : wallHeightSpinnerBg;
      this.context.fillRect(left + 1, top + 1, ui.width - 2, ui.buttonHeight - 1);
      this.context.fillStyle = downHovered ? wallHeightSpinnerHover : wallHeightSpinnerBg;
      this.context.fillRect(left + 1, top + ui.buttonHeight, ui.width - 2, ui.buttonHeight - 1);

      this.context.strokeStyle = wallHeightSpinnerBorder;
      this.context.lineWidth = 1;
      this.context.beginPath();
      this.context.moveTo(left, top + ui.buttonHeight);
      this.context.lineTo(left + ui.width, top + ui.buttonHeight);
      this.context.stroke();

      var arrowInset = 6;
      var upCenterX = left + ui.width / 2;
      var upCenterY = top + ui.buttonHeight / 2;
      var downCenterX = upCenterX;
      var downCenterY = top + ui.buttonHeight + (ui.buttonHeight / 2);

      this.context.fillStyle = wallHeightArrowColor;
      this.context.beginPath();
      this.context.moveTo(upCenterX, upCenterY - 4);
      this.context.lineTo(upCenterX - arrowInset / 2, upCenterY + 2);
      this.context.lineTo(upCenterX + arrowInset / 2, upCenterY + 2);
      this.context.closePath();
      this.context.fill();

      this.context.beginPath();
      this.context.moveTo(downCenterX, downCenterY + 4);
      this.context.lineTo(downCenterX - arrowInset / 2, downCenterY - 2);
      this.context.lineTo(downCenterX + arrowInset / 2, downCenterY - 2);
      this.context.closePath();
      this.context.fill();

      var guardMessage = this.viewmodel.getWallHeightGuardMessage();
      if (guardMessage) {
        this.context.font = "normal 11px Arial";
        this.context.textBaseline = "top";
        this.context.textAlign = "center";
        this.context.lineWidth = 3;
        this.context.strokeStyle = "#ffffff";
        this.context.fillStyle = "#a23b2b";
        this.context.strokeText(guardMessage, ui.centerX, top + ui.totalHeight + 6);
        this.context.fillText(guardMessage, ui.centerX, top + ui.totalHeight + 6);
      }
    }
    /** */
    private drawWall(wall: Wall) {
      var hover = (wall === this.viewmodel.activeWall);
      var selected = (wall === this.viewmodel.selectedWall);
      var color = wallColor;
      if (hover && this.viewmodel.mode == floorplannerModes.DELETE) {
        color = deleteColor;
      } else if (hover) {
        color = wallColorHover;
      } else if (selected) {
        color = wallColorSelected;
      }
      this.drawLine(
        this.viewmodel.convertX(wall.getStartX()),
        this.viewmodel.convertY(wall.getStartY()),
        this.viewmodel.convertX(wall.getEndX()),
        this.viewmodel.convertY(wall.getEndY()),
        (hover || selected) ? wallWidthHover : wallWidth,
        color
      );
      if (!hover && !selected && wall.frontEdge) {
        this.drawEdge(wall.frontEdge, hover);
      }
      if (!hover && !selected && wall.backEdge) {
        this.drawEdge(wall.backEdge, hover);
      }
    }

    /** */
    private drawEdgeLabel(edge: HalfEdge) {
      var pos = edge.interiorCenter();
      var length = edge.interiorDistance();
      if (length < 60) {
        // dont draw labels on walls this short
        return;
      }
      this.context.font = "normal 12px Arial";
      this.context.fillStyle = "#000000";
      this.context.textBaseline = "middle";
      this.context.textAlign = "center";
      this.context.strokeStyle = "#ffffff";
      this.context.lineWidth = 4;

      this.context.strokeText(Dimensioning.cmToMeasure(length),
        this.viewmodel.convertX(pos.x),
        this.viewmodel.convertY(pos.y));
      this.context.fillText(Dimensioning.cmToMeasure(length),
        this.viewmodel.convertX(pos.x),
        this.viewmodel.convertY(pos.y));
    }

    /** */
    private drawEdge(edge: HalfEdge, hover) {
      var color = edgeColor;
      if (hover && this.viewmodel.mode == floorplannerModes.DELETE) {
        color = deleteColor;
      } else if (hover) {
        color = edgeColorHover;
      }
      var corners = edge.corners();

      var scope = this;
      this.drawPolygon(
        Utils.map(corners, function (corner) {
          return scope.viewmodel.convertX(corner.x);
        }),
        Utils.map(corners, function (corner) {
          return scope.viewmodel.convertY(corner.y);
        }),
        false,
        null,
        true,
        color,
        edgeWidth
      );
    }

    /** */
    private drawRoom(room: Room) {
      var scope = this;
      this.drawPolygon(
        Utils.map(room.corners, (corner: Corner) => {
          return scope.viewmodel.convertX(corner.x);
        }),
        Utils.map(room.corners, (corner: Corner) =>  {
          return scope.viewmodel.convertY(corner.y);
        }),
        true,
        roomColor
      );
    }

    /** */
    private drawCorner(corner: Corner) {
      var hover = (corner === this.viewmodel.activeCorner);
      var color = cornerColor;
      if (hover && this.viewmodel.mode == floorplannerModes.DELETE) {
        color = deleteColor;
      } else if (hover) {
        color = cornerColorHover;
      }
      this.drawCircle(
        this.viewmodel.convertX(corner.x),
        this.viewmodel.convertY(corner.y),
        hover ? cornerRadiusHover : cornerRadius,
        color
      );
    }

    /** */
    private drawTarget(x: number, y: number, lastNode) {
      this.drawCircle(
        this.viewmodel.convertX(x),
        this.viewmodel.convertY(y),
        cornerRadiusHover,
        cornerColorHover
      );
      if (this.viewmodel.lastNode) {
        this.drawLine(
          this.viewmodel.convertX(lastNode.x),
          this.viewmodel.convertY(lastNode.y),
          this.viewmodel.convertX(x),
          this.viewmodel.convertY(y),
          wallWidthHover,
          wallColorHover
        );
      }
    }

    /** */
    private drawLine(startX: number, startY: number, endX: number, endY: number, width: number, color) {
      // width is an integer
      // color is a hex string, i.e. #ff0000
      this.context.beginPath();
      this.context.moveTo(startX, startY);
      this.context.lineTo(endX, endY);
      this.context.lineWidth = width;
      this.context.strokeStyle = color;
      this.context.stroke();
    }

    /** */
    private drawPolygon(xArr, yArr, fill, fillColor, stroke?, strokeColor?, strokeWidth?) {
      // fillColor is a hex string, i.e. #ff0000
      fill = fill || false;
      stroke = stroke || false;
      this.context.beginPath();
      this.context.moveTo(xArr[0], yArr[0]);
      for (var i = 1; i < xArr.length; i++) {
        this.context.lineTo(xArr[i], yArr[i]);
      }
      this.context.closePath();
      if (fill) {
        this.context.fillStyle = fillColor;
        this.context.fill();
      }
      if (stroke) {
        this.context.lineWidth = strokeWidth;
        this.context.strokeStyle = strokeColor;
        this.context.stroke();
      }
    }

    /** */
    private drawCircle(centerX, centerY, radius, fillColor) {
      this.context.beginPath();
      this.context.arc(centerX, centerY, radius, 0, 2 * Math.PI, false);
      this.context.fillStyle = fillColor;
      this.context.fill();
    }

    /** returns n where -gridSize/2 < n <= gridSize/2  */
    private calculateGridOffset(n) {
      if (n >= 0) {
        return (n + gridSpacing / 2.0) % gridSpacing - gridSpacing / 2.0;
      } else {
        return (n - gridSpacing / 2.0) % gridSpacing + gridSpacing / 2.0;
      }
    }

    /** */
    private drawGrid() {
      var offsetX = this.calculateGridOffset(-this.viewmodel.originX);
      var offsetY = this.calculateGridOffset(-this.viewmodel.originY);
      var width = this.canvasElement.width;
      var height = this.canvasElement.height;
      for (var x = 0; x <= (width / gridSpacing); x++) {
        this.drawLine(gridSpacing * x + offsetX, 0, gridSpacing * x + offsetX, height, gridWidth, gridColor);
      }
      for (var y = 0; y <= (height / gridSpacing); y++) {
        this.drawLine(0, gridSpacing * y + offsetY, width, gridSpacing * y + offsetY, gridWidth, gridColor);
      }
    }
  }


